import React,{Component} from 'react';
import { Modal } from 'react-bootstrap';
import {Button,ListGroup,ListGroupItem,Row,Col} from "shards-react";
import firebase from '../firebase';
import { toast } from 'react-toastify';
import { AtomSpinner } from 'react-epic-spinners';


export default class AddAttendance extends Component {

  constructor(props) {
    super(props);
  
    this.state = {student_list:[],loading:false,fetched:false};
    this.get_student_list = this.get_student_list.bind(this);
    this.linear_search = this.linear_search.bind(this);
    this.toggle_attendance = this.toggle_attendance.bind(this);
    this.get_attendance_list = this.get_attendance_list.bind(this);
    this.add_attendance = this.add_attendance.bind(this);
  }

  get_student_list=()=>{

      var class_name = this.props.selected_class;

      if(class_name===undefined){
        toast('Insufficient Data !', {containerId: 'A'});
        this.props.handleClose();
        return;
      }
      var that = this;

      this.setState({loading:true,student_list:[]});      
      firebase.firestore().collection('StudentList').doc(class_name).get().then(function(doc){
              var student_list = doc.data().students;
              for(var i=0;i<student_list.length;i++){
                  student_list[i]['attendance_status']=true;
              }
            that.setState({student_list:student_list,loading:false,fetched:true});
      }).catch(function(err){
        console.log(err);
        that.setState({fetched:true,loading:false});
      })
  }

  componentDidUpdate(prevProps){

     if (this.props.selected_class !== prevProps.selected_class) {
           console.log("Class Changed");
           this.setState({fetched:false,student_list:[]});  
           this.get_student_list();
    }

    //please dont touch
    if((!this.state.fetched && !this.state.loading && this.props.show)){
          console.log(this.state);
          this.get_student_list();
    }
  }

  linear_search = (key,arr)=>{

      for(var i=0;i<arr.length;i++){
        if(key===arr[i].roll_no){
            return i;
        }
      }

      return -1;
  }

  toggle_attendance =(id)=>{

        var student_list = this.state.student_list;

        var index  = this.linear_search(id,student_list);

        if(index!==-1){

            student_list[index]['attendance_status'] = !student_list[index]['attendance_status'];
            console.log(student_list); 
            this.setState({student_list:student_list});
        }

  }

  get_attendance_list = ()=>{

        var absent_list = [], present_list =[];
        
        var student_list = this.state.student_list;

        student_list.forEach(function(doc){

            if(doc.attendance_status){
                present_list.push(doc.roll_no+":"+doc.name);
            }
            else{
                absent_list.push(doc.roll_no+":"+doc.name);
            }

        })
        return [absent_list,present_list];

  }

  add_attendance = () =>{

      var attendance_list = this.get_attendance_list();
      var absent_list = attendance_list[0];
      var present_list = attendance_list[1];
      
      var that  = this;
      var code = this.props.selected_class+":"+(this.props.selected_date);
      //this.setState({loading:true});
      var data = {
                  absent_list:absent_list,
                  present_list:present_list,
                  class : this.props.selected_class,
                  date:this.props.selected_date
                  }
      console.log(data);
      firebase.firestore().collection('Attendance').doc(code).set(data).then(function(doc){
          toast('Attendance Marked Succesfully !', {containerId: 'A'});
          that.setState({loading:false});
          that.props.trigger_get_attendance();
          that.props.handleClose();
      }).catch(function(err){
            toast('Error Updating Attendance !', {containerId: 'A'});
            console.log(err);
            that.setState({loading:false});
      })

  }




  render(){
  return (
    <Modal show={this.props.show} onHide={this.props.handleClose}>
        <Modal.Header>
          <Modal.Title>Add Attendance</Modal.Title>
        </Modal.Header>
        <Modal.Body>

        {
          !this.state.loading &&

        <ListGroup flush className={"scroll_list-group"}>
           
              
             {
                    this.state.student_list.map((item,i)=>{
                      return <StudentItem  data={item} 
                                    key={i} 
                                    index={i+1} 
                                    toggle_attendance={this.toggle_attendance}
                                    />
                    })
            }

            {
              (this.state.student_list.length===0) && 

                <div style={{margin: '20%'}} className="text-muted">
                 
                        <div  style={{fontSize:40,color:'blue'}}>
                          {"No Students"}
                        </div>
                        <div style={{marginLeft: "30%",fontSize:50,color:'red'}}>
                             <i class="material-icons">airline_seat_individual_suite</i>
                        </div>

                  
                  </div>

            }
                  

        </ListGroup>       
      }
          { this.state.loading && 
            <AtomSpinner color="blue" />
          }

        </Modal.Body>
        

        <Modal.Footer>
          <Button   theme="info" onClick={this.props.handleClose}>
            Close
          </Button>
      {
          !(this.state.student_list.length===0) &&
          <Button theme="danger" onClick={this.add_attendance}>
            Add
          </Button>
        }
        </Modal.Footer>
      </Modal>
    );
  }
}



class StudentItem extends Component{
  render(){

      const style = (this.props.data.attendance_status)?{fontSize:30,textAlign: 'center',color:'green'}:{fontSize:30,textAlign: 'center',color:'red'};
      const icon_name = (this.props.data.attendance_status)?"done":"cancel";

    return(

          <ListGroupItem className="px-4" >
                <div className="progress-wrapper">
                  <Row>
                      <Col md="2">
                        <div className="blog-comments__avatar mr-3">
                                 <img src={this.props.data.url} alt={this.props.data.name} />
                        </div>
                      </Col>
                      <Col md="8">
                       <strong className=" d-block mb-2" style={{marginTop: '5%',fontSize:20}}>
                            {this.props.data.name}
                        </strong>
                      </Col>
                      <Col md="2" onClick={()=>{this.props.toggle_attendance(this.props.data.roll_no)}}>
                        <strong className=" d-block mb-2" style={style}>
                            <i class="material-icons">{icon_name}</i>
                        </strong>
                      </Col>
                  </Row>
                  </div>
            </ListGroupItem> 
    )
  }
}